import PortfolioExportAggregatedRiskIcon from "@/../public/img/icons/home/portfolio-export-aggregated-risk-icon.svg";
import PortfolioExportHighRiskIcon from "@/../public/img/icons/home/portfolio-export-high-risk-icon.svg";
import QuickBatchIcon from "@/../public/img/icons/home/quick-batch-icon.svg";
import SingleAssetIcon from "@/../public/img/icons/home/single-asset-icon.svg";
import { getConfig } from "@/features/branding";
import { getTools } from "@/features/branding/tools";
import { AuthSession } from "@supabase/supabase-js";
import { HomeDashboardItem } from "./types";
interface HomeDashboardItemWithPrefixes extends HomeDashboardItem {
  toolKeyPrefix: string;
}
export const getDefaultHomeDashboardItems = async (session: AuthSession | null): Promise<HomeDashboardItemWithPrefixes[]> => {
  const {
    riskBands
  } = getConfig();
  const toolPrefixes = (await getTools(session)).map(tool => tool.keyPrefix);
  const quickBatchMaxAddresses = riskBands.quickBatch.maxAddresses;
  return [{
    title: <>
          Understand risk
          <br /> to a single asset
        </>,
    tool: "Single Asset Screen",
    link: "/tools/screening/single",
    icon: <SingleAssetIcon />,
    toolKeyPrefix: "screening.single"
  }, {
    title: <>Compare risk to the same build type in up to {quickBatchMaxAddresses} different locations </>,
    tool: "Quick Batch Screen",
    link: "/tools/screening/batch",
    icon: <QuickBatchIcon />,
    toolKeyPrefix: "screening.batch"
  }, {
    title: <>Understand aggregated risk across an entire portfolio </>,
    tool: "Portfolio Analysis",
    link: "/tools/comprehensive/portfolio-analysis",
    icon: <PortfolioExportAggregatedRiskIcon />,
    toolKeyPrefix: "comprehensive.portfolioInsights"
  }, {
    title: <>Identify high-risk properties within a portfolio </>,
    tool: "Portfolio Analysis",
    link: "/tools/comprehensive/portfolio-analysis",
    icon: <PortfolioExportHighRiskIcon />,
    toolKeyPrefix: "comprehensive.portfolioInsights"
  }].filter(({
    toolKeyPrefix
  }) => toolPrefixes.indexOf(toolKeyPrefix) !== -1);
};